<template>
  <aside class="chat-side-panel">
    <div class="chat-side-panel__header">
      <img
        class="chat-side-panel__avatar"
        :src="require('@/assets/ai-avatar/ai-avatar-2x-zhang.png')"
      />
      <div class="chat-side-panel__meta">
        <div class="chat-side-panel__title">AI 陪练任务</div>
        <div class="chat-side-panel__desc">基于分析报告，已为您生成以下针对性的陪练任务</div>
      </div>
      <i class="chat-side-panel__close icon-close-large-line t-iconfont" @click="close"></i>
    </div>

    <div class="chat-side-panel__body">
      <CollapsibleSplitPanel
        v-model:collapsed="isStudyMode"
        :before-toggle="beforeToggle"
        class="chat-side-panel__split"
        left-collapsed-text="可展开查看任务列表"
        left-title="任务列表"
        mode="switch"
        right-collapsed-text="点击开始学习可模拟陪练"
      >
        <template #left-title>
          <div class="chat-side-panel__section-title">
            <span>任务列表</span>
            <span class="chat-side-panel__action" @click="handleOpenDispatchSelect('batch')">
              一键派发全部任务
            </span>
          </div>
        </template>
        <template #left>
          <section class="chat-side-panel__main">
            <div class="chat-side-panel__cards">
              <div
                v-for="item in taskList"
                :key="item.title"
                class="chat-side-panel__card"
                :class="{
                  'is-active': selectedTaskTitle === item.title,
                  'is-expanded': expandedTaskTitles.includes(item.title)
                }"
              >
                <div class="chat-side-panel__card-top" @click="toggleTask(item)">
                  <div class="chat-side-panel__card-title-wrap">
                    <div class="chat-side-panel__card-title">{{ item.title }}</div>
                  </div>
                  <div class="chat-side-panel__card-actions">
                    <el-button
                      class="chat-side-panel__dispatch"
                      @click.stop="handleOpenDispatchSelect('single', item)"
                    >
                      派发
                    </el-button>
                    <el-button class="chat-side-panel__study" @click.stop="handleStartStudy(item)">
                      <i class="icon-phone-AI-fill t-iconfont"></i>
                      <span>开始学习</span>
                    </el-button>
                  </div>
                </div>
                <template v-if="expandedTaskTitles.includes(item.title)">
                  <div class="chat-side-panel__divider"></div>
                  <div v-if="item.customerProfiles.length" class="chat-side-panel__profiles">
                    <div class="chat-side-panel__content-title">陪练内容</div>
                    <div class="chat-side-panel__profile-item">
                      {{ item.content }}
                    </div>
                    <div
                      v-for="(profile, profileIndex) in item.customerProfiles"
                      :key="`${item.title}-${profile.profile || profileIndex}`"
                      class="chat-side-panel__profile-card"
                    >
                      <div
                        v-if="profile.profile"
                        class="chat-side-panel__profile-item chat-side-panel__profile-item--primary"
                      >
                        <span class="chat-side-panel__profile-label">客户画像：</span>
                        <span>{{ profile.profile }}</span>
                      </div>
                      <div
                        v-if="profile.customerQuote"
                        class="chat-side-panel__profile-item chat-side-panel__profile-item--primary"
                      >
                        <span class="chat-side-panel__profile-label">客户原话：</span>
                        <span>{{ profile.customerQuote }}</span>
                      </div>
                      <div
                        v-if="!profile.profile && !profile.customerQuote"
                        class="chat-side-panel__profile-empty"
                      >
                        暂无可展示画像信息
                      </div>
                      <div
                        v-if="profile.background"
                        class="chat-side-panel__profile-item chat-side-panel__profile-item--secondary"
                      >
                        <span class="chat-side-panel__profile-label">背景描述：</span>
                        <span>{{ profile.background }}</span>
                      </div>
                      <div
                        v-if="profile.initialAttitude"
                        class="chat-side-panel__profile-item chat-side-panel__profile-item--secondary"
                      >
                        <span class="chat-side-panel__profile-label">客户初始态度：</span>
                        <span>{{ profile.initialAttitude }}</span>
                      </div>
                      <div
                        v-if="profile.trainingGoal"
                        class="chat-side-panel__profile-item chat-side-panel__profile-item--secondary"
                      >
                        <span class="chat-side-panel__profile-label">训练目标：</span>
                        <span>{{ profile.trainingGoal }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </section>
        </template>
        <template #right-title>
          <div class="chat-side-panel__practice-title">
            <span>模拟陪练</span>
            <span v-if="activeTask?.title || preTask?.title" class="practice-title__main">
              {{ `（${activeTask?.title || preTask?.title}）` }}
            </span>
            <span v-else class="practice-title__desc"> 在任务列表选择任务“开始学习”模拟陪练 </span>
          </div>
        </template>
        <template #right="{ collapsed }">
          <section v-if="!collapsed" class="chat-side-panel__practice">
            <!-- 陪练中 -->
            <div v-if="activeTask" class="chat-side-panel__practice-card is-call">
              <CallSdkCore
                :params="{
                  taskName: activeTask.title,
                  chatRecordId: chatRecordId
                }"
                @close="closeStudy"
                @over="overStudy"
              ></CallSdkCore>
            </div>
            <!-- 陪练完成---分析 -->
            <div v-else-if="isPracticedOver" class="chat-side-panel__practice-card is-report">
              <PracticeReport
                :params="{
                  chatRecordId: chatRecordId
                }"
                @init="isAnalysis = false"
              ></PracticeReport>
            </div>
            <!-- 分析过 -->
            <!-- 没有分析过 -->
            <div v-else class="chat-side-panel__empty">
              <div class="chat-side-panel__empty-illustration">
                <img
                  alt="缺省插画"
                  class="chat-side-panel__empty-image"
                  :src="require('@/assets/ai-avatar/ai-practice-partner-man.png')"
                />
                <div class="chat-side-panel__empty-image-mask"></div>
              </div>
              <div class="chat-side-panel__empty-text">
                我会基于提炼好的陪练内容，模拟真实跟进客户场景
              </div>
              <div class="chat-side-panel__empty-text">和您陪练，选择一个任务试试吧~</div>
            </div>
          </section>
        </template>
      </CollapsibleSplitPanel>
    </div>
    <PersonSelect
      v-model="selectedEmployees"
      v-model:show="personSelectVisible"
      :max="200"
      @confirm="handleDispatchConfirm"
    />
  </aside>
</template>

<script setup>
import { ref, computed, inject, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import CollapsibleSplitPanel from '@/pages/ai-practice-partner/components/collapsible-split-panel.vue'
import { dispatchTrainTask, batchDispatchTrainTask, getTrainResult } from '@/api/chat.js'
import CallSdkCore from './call-sdk-core/index.vue'
import PracticeReport from './practice-report/index.vue'
import { checkMicrophonePermission } from '@/pages/ai-practice-partner/components/call-sdk-core/call-sdk-core.utils.js'
import PersonSelect from '@/components/ai-person-select-v2/person-select.vue'

defineOptions({
  name: 'AiPracticePartner'
})

const props = defineProps({
  isQoder: {
    type: Boolean,
    default: false
  },
  panelData: {
    type: Object,
    default: () => ({})
  }
})

// 统一分屏内容上下文由 topicAnalyst/index.vue provide，陪练分屏在这里注入自己的数据
const splitPanelContext = inject('topicSplitPanelContext', {})
const attributes = computed(() => {
  return splitPanelContext.practiceAttributes?.value || {}
})
const chatRecordId = computed(() => {
  return props.isQoder ? props.panelData?.chatRecordId || '' : attributes.value?.chatRecordId || ''
})
const emit = defineEmits(['close'])

const taskList = computed(() => {
  const contentList = props.isQoder ? props.panelData?.content : attributes.value?.content

  if (!Array.isArray(contentList) || !contentList.length) {
    return []
  }

  return contentList.map((item, index) => ({
    title: item.topic || `陪练主题${index + 1}`,
    content: item.topicDesc || '',
    raw: item,
    customerProfiles: Array.isArray(item.customerProfiles) ? item.customerProfiles : []
  }))
})

const isStudyMode = ref(false)
const isPracticedOver = ref(false) // 是否 陪练过
const isAnalysis = ref(false) // 是否在分析
const activeTask = ref(null) // 当前陪练的任务
const preTask = ref(null) // 当前陪练过的任务
const selectedTaskTitle = ref('')
const expandedTaskTitles = ref([])

const dispatching = ref(false)
const dispatchContext = ref({
  type: 'single',
  task: null
})
const selectedEmployees = ref([])
const personSelectVisible = ref(false)

const toggleTask = (item) => {
  if (selectedTaskTitle.value === item.title) {
    selectedTaskTitle.value = ''
    expandedTaskTitles.value = []
    return
  }

  selectedTaskTitle.value = item.title
  expandedTaskTitles.value = [item.title]
}

// 拨号参数获取
const handleStartStudy = async (item) => {
  const hasPermission = await checkMicrophonePermission()
  if (!hasPermission) {
    ElMessage.error('当前浏览器未授予麦克风访问权限，无法启动语音陪练，请检查后重试～')
    return
  }
  selectedTaskTitle.value = item.title
  expandedTaskTitles.value = [item.title]
  activeTask.value = item
  isStudyMode.value = true
}

// 如果关闭折叠
watch(
  () => isStudyMode.value,
  (val) => {
    if (!val) {
      activeTask.value = null
    }
  }
)

const beforeToggle = (val) => {
  // 如果是开启陪练
  if (activeTask.value) {
    // 如果是陪练完成
    if (isPracticedOver.value) return true
    return
  }
  return true
}

const closeStudy = () => {
  activeTask.value = null
  isStudyMode.value = false
}

const overStudy = () => {
  preTask.value = activeTask.value
  activeTask.value = null
  isPracticedOver.value = true
}

const handleOpenDispatchSelect = (type, task = null) => {
  if (dispatching.value) return

  dispatchContext.value = {
    type,
    task
  }
  console.log('dispatchContext', dispatchContext.value)
  console.log('selectedEmployees.value', selectedEmployees.value)
  selectedEmployees.value = []
  personSelectVisible.value = true
}

const handleDispatchRequest = async () => {
  const baseParams = {
    chatRecordId: chatRecordId.value,
    userRangePojoList: selectedEmployees.value
  }

  const isBatchDispatch = dispatchContext.value.type === 'batch'
  const response = isBatchDispatch
    ? await batchDispatchTrainTask({
        ...baseParams,
        taskNameList: taskList.value.map((item) => item.title)
      })
    : await dispatchTrainTask({
        ...baseParams,
        taskName: dispatchContext.value.task?.title || ''
      })

  ElMessage.success(response?.result?.msg || response?.msg || '派发成功')
}

const handleDispatchConfirm = async () => {
  console.log('selectedEmployees', selectedEmployees.value)
  if (!selectedEmployees.value.length) {
    ElMessage.warning('请选择员工或者部门')
    return
  }

  dispatching.value = true
  try {
    await handleDispatchRequest()
  } finally {
    dispatching.value = false
  }
}

const close = () => {
  emit('close')
}

watch(
  taskList,
  (list) => {
    if (!list.length) {
      activeTask.value = null
      selectedTaskTitle.value = ''
      expandedTaskTitles.value = []
      return
    }

    if (selectedTaskTitle.value && !list.some((item) => item.title === selectedTaskTitle.value)) {
      selectedTaskTitle.value = list[0].title
    }

    if (!selectedTaskTitle.value) {
      selectedTaskTitle.value = list[0].title
    }

    expandedTaskTitles.value = [selectedTaskTitle.value]
  },
  {
    immediate: true
  }
)

onMounted(() => {
  getTrainResult({
    chatRecordId: chatRecordId.value
  }).then((res) => {
    isPracticedOver.value = !!res.result.trainRecordId
    preTask.value = { title: res.result.taskName }
  })
})
</script>

<style lang="scss" scoped>
.chat-side-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #fefefe;
  border-radius: 12px;
  .chat-side-panel__close {
    cursor: pointer;
  }
  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 0 16px;
    background: #fff;
  }

  &__avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 50%;
    background: linear-gradient(135deg, #dbe7ff 0%, #f4eefe 100%);
    box-shadow: 0 4px 12px rgba(21, 116, 255, 0.12);
  }

  &__meta {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #323233;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: #646566;
  }

  &__close {
    font-size: 16px;
    color: #323233;
  }

  &__body {
    display: flex;
    flex: 1;
    min-height: 0;

    :deep(.chat-side-panel__split) {
      .panel--right {
        background:
          linear-gradient(179deg, rgba(182, 206, 255, 0.25) 0%, rgba(255, 255, 255, 0.5) 20%),
          #ffffff;
      }
    }
  }

  &__split {
    flex: 1;
    min-width: 0;
    min-height: 0;
  }

  &__practice-title {
    .practice-title {
      &__desc {
        margin-left: 12px;
        font-size: 12px;
        font-weight: normal;
        line-height: 16px;
        letter-spacing: 0em;
        color: #646566;
      }
    }
  }

  &__main,
  &__practice {
    height: 100%;
    min-height: 0;
    padding: 16px;
    box-sizing: border-box;
    // background: #ffffff;
    // border-radius: 16px;
    box-shadow: 0 8px 24px rgba(31, 35, 41, 0.08);
  }

  &__section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
  }

  &__action {
    font-size: 12px;
    font-weight: 400;
    color: #7a52f4;
    cursor: pointer;
  }

  &__cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    padding-top: 2px;
    overflow: auto;
  }

  &__card {
    padding: 12px;
    border: 1px solid #e5e6eb;
    border-radius: 12px;
    background: #ffffff;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease,
      border-color 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 16px rgba(31, 35, 41, 0.05);
    }

    &.is-active {
      transform: unset !important;
      border-color: #7a52f4;
      box-shadow: 0 10px 24px rgba(114, 46, 209, 0.12);
    }
  }

  &__card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
  }

  &__card-title-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    flex: 1;
  }

  &__card-title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
  }

  &__card-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  &__dispatch,
  &__study {
    min-height: unset;
    height: 26px;
    padding: 4px 8px;
    border-radius: 8px;
    font-family: 'PingFang SC', sans-serif;
    line-height: 16px;
  }

  &__dispatch {
    width: 40px;
    color: #ffffff;
    font-size: 12px;
    background: #7a52f4;
    border-color: #7a52f4;
  }

  &__study {
    width: 90px;
    gap: 8px;
    color: #5952ff;
    font-size: 13px;
    background: linear-gradient(286deg, #eef2ff 1%, #f5f3ff 99%);
    border: 1px solid rgba(124, 58, 237, 0.15);

    .t-iconfont {
      margin-right: 8px;
      font-size: 14px;
      line-height: 14px;
      background: linear-gradient(315deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &__divider {
    margin: 12px 0;
    border-top: 1px dashed #e5e6eb;
  }

  &__content {
    padding: 12px;
    border-radius: 12px;
    background: #f7f8fa;
    border: 1px solid #e5e6eb;
  }

  &__content-title {
    position: relative;
    padding-left: 10px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #323233;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      width: 3px;
      height: 12px;
      border-radius: 4px;
      background: #7a52f4;
    }
  }

  &__content-text {
    font-size: 14px;
    line-height: 22px;
    color: #323233;
  }

  &__profiles {
    margin-top: 12px;
    padding: 12px;
    border-radius: 12px;
    background: #f7f8fa;
    border: 1px solid #e5e6eb;
  }

  &__profile-card {
    margin-top: 12px;
    padding: 12px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #e5e6eb;
    box-shadow: 0 4px 12px rgba(31, 35, 41, 0.04);

    &:first-of-type {
      margin-top: 0;
    }
  }

  &__profile-empty {
    font-size: 13px;
    line-height: 22px;
    color: #969799;
  }

  &__profile-item {
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    line-height: 22px;
    color: #646566;

    span:last-child {
      flex: 1;
      min-width: 0;
      word-break: break-word;
    }
  }

  &__profile-item + &__profile-item {
    margin-top: 8px;
  }

  &__profile-item--primary {
    color: #323233;
  }

  &__profile-item--secondary {
    padding-top: 8px;
    border-top: 1px dashed #e5e6eb;
  }

  &__profile-label {
    flex-shrink: 0;
    color: #323233;
    font-weight: 600;
  }

  &__practice {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    // background:
    //   linear-gradient(179deg, rgba(182, 206, 255, 0.25) 0%, rgba(255, 255, 255, 0.5) 13%), #ffffff;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 375px;
    height: 100%;
    max-height: 732px;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;
    background: #f7f8fa;
    border: 2px solid #f2f3f5;
    border-radius: 24px;
  }

  &__empty-illustration {
    position: relative;
    width: 130px;
    height: 148px;
  }

  &__empty-image {
    display: block;
    width: 130px;
    height: 148px;
    object-fit: cover;
  }

  &__empty-image-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    background: linear-gradient(180deg, rgba(247, 248, 250, 0) 0%, #f7f8fa 100%);
  }

  &__empty-text {
    max-width: 322px;
    margin-top: 16px;
    font-size: 14px;
    line-height: 20px;
    color: #646566;

    & + & {
      margin-top: 0;
    }
  }

  &__practice-card {
    width: 100%;
    height: 100%;
    max-height: 732px;
    max-width: 375px;
    padding: 12px 12px 0;
    border-radius: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 12px 32px rgba(31, 35, 41, 0.08);
  }
  .is-call {
    background-color: #f2f3f5;
  }
  .is-report {
    background: #ffffff;
  }
}
</style>
